import React from 'react';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import PropTypes from 'prop-types';
import style from './style.module.less';
import { CHECKBOX, DATE_PICKER, DATE_RANGE, BILLING_DATE_RANGE, DROP_DOWN, TEXTBOX } from './constants';
import Checkbox from './filters/checkbox';
import DatePicker from './filters/date-picker';
import DateRange from './filters/date-range';
import BillingDateRange from './filters/date-range/billing-date-range';
import Dropdown from './filters/dropdown';
import Textbox from './filters/textbox';

const Filters = {
  [CHECKBOX]: Checkbox,
  [DATE_PICKER]: DatePicker,
  [DATE_RANGE]: DateRange,
  [BILLING_DATE_RANGE]: BillingDateRange,
  [DROP_DOWN]: Dropdown,
  [TEXTBOX]: Textbox,
};

const ParameterInputWithLabel = ({ key, filterProps }) => {
  const { label, type } = filterProps;
  const ReportFilter = Filters[type];
  return (
    <div key={key} className={style['filter-input']}>
      <label>{label}</label>
      <ReportFilter props={filterProps} />
    </div>
  );
};

ParameterInputWithLabel.propTypes = {
  key: PropTypes.number.isRequired,
  filterProps: PropTypes.shape({
    apiKey: PropTypes.string,
    filterType: PropTypes.string,
    label: MessageDescriptorPropType,
    type: PropTypes.string,
  }).isRequired,
};

export default ParameterInputWithLabel;
